import React from 'react';

import {removeUserRoles, removeUserRolesFailure, removeUserRolesSuccess} from 'src/openapi/apis/UserRoleControllerApi';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {OnCloseNote, Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    email: string,
    onClose: OnCloseNote,
    onRemoveHandle: (email: string) => void,
};

export const PushNotificationRemoveUser = (props: Props) => {
    const {
        email,
        onClose,
        onRemoveHandle,
    } = props;

    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();

    const onClick = async () => {
        const response = await dispatch(removeUserRoles({email}));

        if (response.type === removeUserRolesSuccess.type) {
            await onClose(`${email}`);
            onRemoveHandle(email);
        }

        if (response.payload.error && response.type === removeUserRolesFailure.type) {
            onCreateNote({
                id: removeUserRolesFailure.type,
                status: Status.ERROR,
                message: response.payload.data.message,
                buttonProps: {icon: Icons.CLOSE},
                autoHideTimeout: 10000,
            });
        }
    };

    return (
        <Group justify="space-between" gap="xxl">
            <span>
                Are you sure you want to delete this user?
            </span>
            <FlatButton onClick={onClick}>Delete</FlatButton>
        </Group>
    );
};
